import { memo, useCallback } from "react";
import { useField } from "formik";
import PropTypes from "prop-types";
import "./Switch.scss";
import classNames from "classnames";

const SwitchFormik = props => {
	const { toggle = () => {}, id, isRequired = false, title = "", description = "", name } = props;
	const [field, meta, helpers] = useField(props);
	const { setValue } = helpers;

	const onChange = useCallback(event => {
		const value = event.target.checked;
		setValue(value);
		toggle(event);
	});

	const switchClassName = classNames({
		switch: true,
		"switch--required": isRequired,
		"switch--error": meta.touched && meta.error,
	});

	return (
		<div className={switchClassName}>
			<div className="switch__component">
				<input
					{...field}
					id={id}
					name={name}
					type="checkbox"
					className="switch__input"
					onChange={onChange}
					checked={field.value}
				/>
				<label htmlFor={id} className="switch__bullet" data-testid={props["data-testid"]} />
			</div>
			<label htmlFor={id} className="switch__title">
				{title}
			</label>
			<label htmlFor={id} className="switch__description">
				{description}
			</label>
		</div>
	);
};

SwitchFormik.propTypes = {
	id: PropTypes.string,
	title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	description: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	toggle: PropTypes.func,
	isRequired: PropTypes.bool,
	name: PropTypes.string,
	"data-testid": PropTypes.string,
};

export default memo(SwitchFormik);
